import React from 'react';
import BlockWrapper from './BlockWrapper';
import CardsSlider from '../CardsSlider/CardsSlider';

const CardsSliderBlock = ({ block }) => {
  return (
    <BlockWrapper>
      <CardsSlider items={block.cards} />
    </BlockWrapper>
  );
};

export default CardsSliderBlock;
